import { render, staticRenderFns } from "./heshid.vue?vue&type=template&id=a149724a"
import script from "./heshid.vue?vue&type=script&lang=js"
export * from "./heshid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports